import React, { useCallback, useState, useEffect, useRef } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';

import UserAPI from '../../api/User';
import User from '../../models/User';
import Utils from '../../utils/utils';
import Icons from '../../utils/Icons';
import Screen from '../../utils/Screen';
import Accordion from '../widget/Accordion';
import FriendCard from '../friends/FriendCard';
import i18n from '../../i18n';
import Loading from '../common/Loading';
import SponsorshipPopup from '../../components/popup/SponsorshipPopup';
import Banner from '../banner/Banner';

export const Sponsorship = (props) => {
    const [isCopiedActive, setIsCopiedActive] = useState(false);
    const [sponsorhipKey, setSponsorhipKey] = useState('');
    const [sponsoredFriends, setSponsoredFriends] = useState();
    const [isViewMoreClick, setIsViewMoreClick] = useState(false);
    const [heightFriendList, setHeightFriendList] = useState();
    const [openPopup, setOpenPopup] = useState(false);
    const [showCollectionReferralBanner, setCollectionReferralBannerVisibility] = useState(false);

    const friendListRef = useRef();
    const navigate = useNavigate();

    const defaultProfile = `${Utils.getCloudfrontDomain()}/images/website/icon_default_profile.jpg`;

    useEffect(() => {
        UserAPI.getSponsorshipKey().then((response) => setSponsorhipKey(response.key));
        UserAPI.getSponsoredFriends().then((response) => setSponsoredFriends(response));
    }, []);

    useEffect(() => {
        if (props.user && props.user.has('is_he_collection')) {
            setCollectionReferralBannerVisibility(props.user.get('is_he_collection'));
        }
    }, [props.user]);

    useEffect(() => {
        setHeightFriendList(
            `${
                isViewMoreClick
                    ? friendListRef.current.scrollHeight.toString()
                    : Screen.isMobile()
                    ? '360'
                    : '375'
            }px`
        );
    }, [isViewMoreClick]);

    const handleClickCopy = useCallback(() => {
        setIsCopiedActive(true);
        setTimeout(() => setIsCopiedActive(false), 1000);
    }, []);

    const handleClickProfil = useCallback(() => {
        navigate(i18n.t('url:user_edit', { id: props.user.get('id') }));
    }, [props.user, navigate]);

    const handleClickView = useCallback(() => {
        setIsViewMoreClick(!isViewMoreClick);
    }, [isViewMoreClick]);

    const handleOnCloseCollectionReferralBanner = useCallback(() => {
        setCollectionReferralBannerVisibility(false);
    }, []);

    return (
        <div
            className={classNames('container-sponsorship', {
                unlogged: !props.accessToken
            })}
        >
            {showCollectionReferralBanner && (
                <Banner
                    title={i18n.t('collection:referral-banner.title')}
                    text={i18n.t('collection:referral-banner.text')}
                    onClose={handleOnCloseCollectionReferralBanner}
                />
            )}
            <h2>{i18n.t('sponsorship:invite-friends')}</h2>
            {props.accessToken && (
                <>
                    <p className="link-text">{i18n.t('sponsorship:share-code')}</p>
                    <div className="sponsorship-key-container">
                        <CopyToClipboard text={sponsorhipKey} onCopy={handleClickCopy}>
                            <div
                                className={classNames('sponsorship-key', {
                                    copied: isCopiedActive
                                })}
                            >
                                {isCopiedActive ? i18n.t('common:copied') : sponsorhipKey}
                            </div>
                        </CopyToClipboard>
                    </div>
                </>
            )}
            <div className="container-sponsorship-picture">
                {props.accessToken && (
                    <div className="profil-picture">
                        <div className="circle-profil">
                            {props.user ? (
                                <img
                                    src={
                                        props.user.get('images')[0]
                                            ? props.user.get('images')[0].cdn_link
                                            : defaultProfile
                                    }
                                    onClick={handleClickProfil}
                                />
                            ) : (
                                <Loading width="50%" />
                            )}
                        </div>
                    </div>
                )}
                <img
                    src={`${Utils.getCloudfrontDomain()}/images/website/sponsorship/referral-${
                        Screen.isTabletOrUpper() ? 'desktop' : 'mobile'
                    }.svg`}
                />
            </div>
            <div className="explanation-text">{i18n.t('sponsorship:sponsorship_explanation-text')}</div>
            {sponsoredFriends && sponsoredFriends.total > 0 && (
                <div className="container-total-sponsored">
                    <p className="text-total-sponsored">{i18n.t('sponsorship:sponsorship_rewards_text')}</p>
                    <div className="total-sponsored">
                        <div>{sponsoredFriends.total}</div>
                        <div>{i18n.t('common:accepted')}</div>
                        <div>{i18n.t('sponsorship:friends_code_text')}</div>
                    </div>
                </div>
            )}
            {(!props.accessToken || (sponsoredFriends && sponsoredFriends.total === 0)) && (
                <div className="container-earn-reward">
                    <h3>{i18n.t('sponsorship:earn-rewards')}</h3>
                    <div className="pictos-rewards">
                        <div className="ambassador-badge">
                            <span
                                className={`${
                                    props.user && props.user.get('is_he_collection')
                                        ? 'icon-collection-referral-badge'
                                        : 'icon-badge_referral_locked'
                                }`}
                            >
                                {Icons.transform(props.user && props.user.get('is_he_collection') ? 84 : 86)}
                            </span>
                            <p>{i18n.t('sponsorship:ambassador-badge')}</p>
                        </div>
                        <div className="guestpoint">
                            <span>+250</span>
                            <p className="guestpoint-title">Guestpoints</p>
                            <p className="guestpoint-text">
                                {i18n.t('sponsorship:sponsorship_guestpoint-text')}
                            </p>
                        </div>
                    </div>
                </div>
            )}
            <div className="button-invite">
                <button
                    className="btn btn-primary"
                    // eslint-disable-next-line react/jsx-no-bind
                    onClick={() =>
                        props.accessToken ? setOpenPopup(true) : document.getElementById('signin').click()
                    }
                >
                    {props.accessToken ? i18n.t('sponsorship:invite-friends') : i18n.t('common:connect')}
                </button>
            </div>
            {sponsoredFriends && sponsoredFriends.total > 0 && (
                <div className="container-my-friends">
                    <h3>{i18n.t('sponsorship:my_friends')}</h3>
                    <div
                        className="container-friend-list"
                        style={{
                            height: sponsoredFriends.total < 6 ? 'auto' : heightFriendList
                        }}
                        ref={friendListRef}
                    >
                        {sponsoredFriends.sponsored_users.map((friend) => (
                            <FriendCard key={friend.id} friend={friend} />
                        ))}
                    </div>
                    {sponsoredFriends.total > 5 && (
                        <button
                            className={classNames('view-all', {
                                expanded: isViewMoreClick
                            })}
                            onClick={handleClickView}
                        >
                            {`${i18n.t('common:view.all')} (${
                                sponsoredFriends.total > 20
                                    ? i18n.t('sponsorship:20_latest_updates')
                                    : sponsoredFriends.total
                            })`}
                            <i className="fa fa-angle-down down-arrow" />
                        </button>
                    )}
                </div>
            )}
            <div className="container-question">
                <h3>{i18n.t('sponsorship:sponsorship_have-a-question')}</h3>
                <div className="container-accordion">
                    {_.times(5, (i) => (
                        <Accordion
                            key={i + 1}
                            id={`question${i + 1}`}
                            title={i18n.t(`sponsorship:sponsorship_question${i + 1}`)}
                            description={i18n.t(`sponsorship:sponsorship_answer${i + 1}`)}
                        />
                    ))}
                </div>
            </div>
            <SponsorshipPopup
                sponsorhipKey={sponsorhipKey}
                openPopup={openPopup}
                setOpenPopup={setOpenPopup}
                user={props.user}
            />
        </div>
    );
};

Sponsorship.propTypes = {
    accessToken: PropTypes.bool,
    user: PropTypes.instanceOf(User)
};

const mapStateToProps = (state) => ({
    accessToken: Boolean(state.auth.accessToken),
    user: state.user
});

export default connect(mapStateToProps)(Sponsorship);
